// extracted by mini-css-extract-plugin
export default {"Box":"card-internal-content-module__Box--g6fvU","Box_1":"card-internal-content-module__Box_1--RQ5Vy","Box_2":"card-internal-content-module__Box_2--oIZMh"};